export default __webpack_public_path__ + "static/media/home-banner-2.c6bb221e.png";